export default class MobileSearch {
    private readonly header: HTMLElement;
    private isSearchVisible = false;

    constructor(el: HTMLElement) {
        this.header = el;

        this.init();
    }

    public init(): void {
        this.addListeners();
    }

    public addListeners(): void {
        this.header.querySelector('._js-mobile-search').addEventListener('click', this.toggleGlobalSearch);
        this.header.querySelector('._js-close').addEventListener('click', this.toggleGlobalSearch);
    }

    public toggleGlobalSearch = (): void => {
        if (this.isSearchVisible) {
            this.header.querySelector('._js-search-form').classList.remove('active');
            this.header.classList.remove('search-active');
            this.isSearchVisible = false;
        } else {
            this.header.querySelector('._js-search-form').classList.add('active');
            this.header.classList.add('search-active');
            this.isSearchVisible = true;
        }
    }
}